<p-toast></p-toast>

<div class="formgrid grid">
    <div class="col-12">
        <div class="flex flex-column gap-3">
            <div class="flex align-items-center gap-2">
                <label class="font-medium">Adresse sélectionnée:</label>
                <p-button 
                    icon="pi pi-search" 
                    label="Rechercher une adresse"
                    styleClass="p-button-outlined"
                    (onClick)="rechercherAdresse()">
                </p-button>
            </div>
            
            <div *ngIf="nouvelleAdresse && nouvelleAdresse.numero" class="flex flex-column gap-3">
                <p-card styleClass="surface-50">
                    <div class="flex flex-column gap-2 text-sm">
                        <div class="font-semibold">Adresse trouvée:</div>
                        <div *ngIf="nouvelleAdresse.numero || nouvelleAdresse.rue">
                            <i class="pi pi-map-marker mr-2"></i>
                            <span>{{nouvelleAdresse.numero}} {{nouvelleAdresse.rue}}</span>
                        </div>
                        <div *ngIf="nouvelleAdresse.municipalite">
                            <i class="pi pi-building mr-2"></i>
                            <span>{{nouvelleAdresse.municipalite}}, {{nouvelleAdresse.province}}</span>
                        </div>
                        <div *ngIf="nouvelleAdresse.codePostal">
                            <i class="pi pi-envelope mr-2"></i>
                            <span>{{nouvelleAdresse.codePostal}}</span>
                        </div>
                    </div>
                </p-card>
                
                <div class="flex flex-column gap-2">
                    <label for="nomAdresse" class="font-medium">Nom de l'adresse <span class="text-red-500">*</span></label>
                    <input id="nomAdresse" 
                        type="text" 
                        pInputText 
                        [(ngModel)]="nouvelleAdresse.nom" 
                        placeholder="Entrez un nom pour cette adresse (ex: Entrepôt principal, Bureau satellite, etc.)"
                        class="w-full">
                    <small class="text-500">Ce nom sera utilisé pour identifier cette adresse dans la liste.</small>
                </div>
            </div>
            
            <div *ngIf="!nouvelleAdresse || !nouvelleAdresse.numero" class="text-center text-500 p-3">
                <i class="pi pi-info-circle mr-2"></i>
                Aucune adresse sélectionnée. Cliquez sur "Rechercher une adresse" pour en choisir une.
            </div>
        </div>
    </div>

    <div class="col-12 flex justify-content-end gap-2 mt-4">
        <p-button
            label="Annuler" 
            icon="pi pi-times" 
            styleClass="p-button-text"
            (onClick)="annuler()">
        </p-button>
        <p-button
            label="Ajouter" 
            icon="pi pi-check" 
            styleClass="p-button-success"
            [disabled]="!nouvelleAdresse || !nouvelleAdresse.numero || !nouvelleAdresse.nom || nouvelleAdresse.nom.trim() === '' || enChargement"
            [loading]="enChargement"
            (onClick)="confirmer()">
        </p-button>
    </div>
</div>

